module.exports = __webpack_public_path__ + "static/ukraine-6a9e07596bade0e2b83cb1cdeb54a5fd.png";